import { GOOGLE_CLIENT_ID, GOOGLE_SDK_URL } from './config';

/**
 * Carga perezosa de Google Identity Services.
 *
 * El script SOLO se descarga si hay un client ID configurado. Sin credencial no
 * se pide ningún recurso externo, que es lo que permite que el registro por
 * correo funcione sin depender de Google.
 */
let promesaCarga = null;

export function googleDisponible() {
    return !!GOOGLE_CLIENT_ID;
}

export function cargarSdkGoogle() {
    if (!googleDisponible()) {
        return Promise.reject(new Error('Google no está configurado.'));
    }

    if (window.google && window.google.accounts && window.google.accounts.id) {
        return Promise.resolve(window.google);
    }

    if (promesaCarga) {
        return promesaCarga;
    }

    promesaCarga = new Promise((resolver, rechazar) => {
        const existente = document.querySelector('script[data-sp-google]');

        if (existente) {
            existente.addEventListener('load', () => resolver(window.google));
            existente.addEventListener('error', () => rechazar(new Error('No se pudo cargar Google.')));
            return;
        }

        const script = document.createElement('script');
        script.src = GOOGLE_SDK_URL;
        script.async = true;
        script.defer = true;
        script.setAttribute('data-sp-google', '1');
        script.onload = () => resolver(window.google);
        script.onerror = () => {
            promesaCarga = null;
            rechazar(new Error('No se pudo cargar Google.'));
        };
        document.head.appendChild(script);
    });

    return promesaCarga;
}

/**
 * Dibuja el botón oficial de Google dentro del contenedor indicado y resuelve
 * con el `id_token` cuando el usuario completa el flujo.
 *
 * Se usa el botón renderizado por Google (y no uno propio) porque es lo que
 * exigen las políticas de marca de Google Sign-In.
 */
export function montarBotonGoogle(contenedor, alRecibirToken, alFallar) {
    if (!contenedor) return;

    cargarSdkGoogle()
        .then((google) => {
            google.accounts.id.initialize({
                client_id: GOOGLE_CLIENT_ID,
                callback: (respuesta) => {
                    if (respuesta && respuesta.credential) {
                        alRecibirToken(respuesta.credential);
                    } else if (alFallar) {
                        alFallar(new Error('Google no devolvió credenciales.'));
                    }
                }
            });

            google.accounts.id.renderButton(contenedor, {
                type: 'standard',
                theme: 'outline',
                size: 'large',
                text: 'continue_with',
                shape: 'pill',
                logo_alignment: 'center',
                locale: 'es',
                width: Math.min(contenedor.offsetWidth || 320, 400)
            });
        })
        .catch((e) => {
            if (alFallar) alFallar(e);
        });
}
